﻿﻿import { TicketVisibility } from '../../enums/index';

export interface ITicketNoteRequest {
    id: number;
    ticketId: number;
    parentMessageId: number;
    createdDateTime: string;
    visibility: TicketVisibility;
    message: string;
    to: string;
    files: File;
}
